import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class RetryPaymentArgs {
  @Field()
  invoiceId!: string
}
